"use strict";

const Button = require("app/shared/components/Button/button");
const Icon = require("app/shared/components/Icon/icon");
const Popbox = require("app/shared/components/Popover/popbox");
const DatePicker =  require("app/shared/components/DatePicker/date-picker");
const TextArea = require("app/shared/components/TextArea/text-area");
const BooleanInput = require("app/shared/components/BooleanInput/boolean-input");
const Tooltip = require("app/shared/components/Tooltip/tooltip");
const dealsAPI = require("app/util/api/deals");
const dealFreezeReasonsAPI = require("app/util/api/deal-freeze-reasons");
const SignalActions = require("app/shared/actions/signal-actions");
const _ = require("underscore");
const pluralize = require("app/util/formatter/text").pluralize;

const FAQ_URL = "https://ajuda.agendor.com.br/pt-BR/articles/3921106-o-que-acontece-quando-congelamos-um-negocio";

const FreezeDealButton = React.createClass({
  propTypes: {
    frozen: React.PropTypes.bool.isRequired,
    dealId: React.PropTypes.number.isRequired,
    frozenAt: React.PropTypes.string,
    unfreezeAt: React.PropTypes.string,
    reasonId: React.PropTypes.number,
    description: React.PropTypes.string
  },
  getInitialState: function() {
    let frozenDate = this.props.frozenAt
      ? moment(this.props.frozenAt).format(DatePicker.sysDateFormat)
      : null;
    let unfreezeDate = this.props.unfreezeAt
      ? moment(this.props.unfreezeAt).format(DatePicker.sysDateFormat)
      : null;

    return ({
      frozen: this.props.frozen,
      showPopbox: false,
      loading: true,
      saving: false,
      frozenDate: frozenDate,
      unfreezeDate: unfreezeDate,
      reasons: [],
      selectedReasonId: this.props.reasonId,
      description: this.props.description
    });
  },
  componentDidMount: function() {
    dealFreezeReasonsAPI.get(this.onFetchReasons, this.onError);
  },
  getType: function() {
    return this.state.frozen ? "primary" : "default";
  },
  getIcon: function() {
    return this.state.frozen ? "unfreeze" : "freeze";
  },
  getText: function() {
    if (this.state.frozen) {
      return (
        this.state.saving
        ? "Descongelando negócio..."
        : "Descongelar negócio"
      );
    } else {
      return (
        this.state.saving
        ? "Congelando negócio..."
        : "Congelar negócio"
      );
    }
  },
  getFormattedFrozenDate: function() {
    return moment(this.state.frozenDate).format("DD/MM/YYYY");
  },
  getDaysToUnfreezeMessage: function() {
    if (!this.state.unfreezeDate)
      return "Data de congelamento indefinida";

    const daysDiff = moment(this.state.unfreezeDate).diff(moment(), "days") + 1;
    const daysText = pluralize("dia", "dias", daysDiff, daysDiff === 0);

    return `Previsão para descongelar: ${daysDiff} ${daysText}`;
  },
  getSaveButtonMessage: function() {
    if (!this.hasSelectedReason() && !this.isUnfreezeDateInFuture())
      return "Para salvar, selecione a data prevista para o descongelamento e o motivo de congelamento.";

    if (!this.hasSelectedReason())
      return "Para salvar, selecione o motivo do congelamento."

    if (!this.isUnfreezeDateInFuture())
      return "Para salvar, você precisa selecionar uma data futura para o descongelamento.";

    return null;
  },
  renderSelectedReason: function() {
    if (!this.hasSelectedReason())
      return "Indefinido";

    let selectedReason = this.state.reasons.find(reason => (
      reason.id === this.state.selectedReasonId
    ));

    if (!selectedReason)
      return null;

    return (
      <Tooltip title={this.state.description}>
        <span className={this.hasDescription() ? "u-bb-dots" : ""}>
          {selectedReason.name}
        </span>
      </Tooltip>
    );
  },
  isUnfreezeDateInFuture: function() {
    return moment().isBefore(this.state.unfreezeDate);
  },
  areFieldsValid: function() {
    return this.hasSelectedReason() && this.isUnfreezeDateInFuture();
  },
  hasSelectedReason: function() {
    return !!this.state.selectedReasonId;
  },
  hasDescription: function() {
    return !!this.state.description;
  },
  onClick: function() {
    if (this.state.frozen) {
      this.onUnfreeze();
    } else {
      this.setState({ showPopbox: true });
    }
  },
  onFetchReasons: function(data) {
    let reasons = data.map(reason => ({ id: reason.idMotivoCongelamentoNegocio }))
    this.setState({ reasons: data, loading: false });
  },
  onFreeze: function() {
    this.setState({ saving: true, showPopbox: false });

    let params = {
      deal_freeze: {
        active: true,
        unfreeze_at: this.state.unfreezeDate,
        deal_freeze_reason_id: this.state.selectedReasonId,
        description: this.state.description
      }
    };

    dealsAPI.partialUpdate(
      this.props.dealId,
      params,
      this.afterFreeze,
      this.onError
    );
  },
  afterFreeze: function() {
    this.setState({
      frozen: true,
      saving: false,
      showPopbox: false,
      frozenDate: moment().format(DatePicker.sysDateFormat)
    });
  },
  onUnfreeze: function() {
    this.setState({ saving: true });

    let params = {
      deal_freeze: {
        active: false
      }
    };

    dealsAPI.partialUpdate(
      this.props.dealId,
      params,
      this.afterUnfreeze,
      this.onError
    );
  },
  afterUnfreeze: function() {
    this.setState({
      frozen: false,
      saving: false,
      frozenDate: null,
      unfreezeDate: null,
      selectedReasonId: null,
      description: null
    });
  },
  onError: function(error) {
    this.setState({ saving: false });

    let message = "Ocorreu um erro inesperado, " +
      "se persistir entre em contato com o nosso suporte.";

    if (error && error.status === 403) {
      message = "Você não possui privilégio para editar um negócio. " +
        "Contate o administrador de sua conta para lhe conceder este " +
        "privilégio em <a href='/sistema/grupos'>Grupos</a>.";
    }

    SignalActions.show({
      message: message,
      type: "warning",
      hideTimeout: 5000
    });
  },
  onSelectDate: function(date) {
    this.setState({ unfreezeDate: date });
  },
  onSelectReason: function(reason) {
    this.setState({ selectedReasonId: reason.id });
  },
  onChangeDescription: function(event) {
    this.setState({ description: event.target.value });
  },
  onClosePopbox: function() {
    this.setState({ showPopbox: false });
  },
  renderPlaceholder: function() {
    return (
      <div className="bg-white u-boxShadow-light br-4 b-light ovf-h d-f">
        <div className="w-230 p-5 p-r">
          <div className="dealLossReason-title--loading"></div>
          <div className="dealLossReason-datePicker-monthSelector--loading"></div>
          <ul className="m-5 d-b">
            {_.range(0, 7).map(i => (
              <li key={i} className="dealLossReason-datePicker-weekItem--loading" />
            ))}
          </ul>
          <ul className="m-5">
            {_.range(0, 30).map(i => (
              <li key={i} className="dealLossReason-datePicker-dayItem--loading" />
            ))}
          </ul>
        </div>
        <div className="w-230 p-5 p-r bg-lightGreyBlue">
          <div className="dealLossReason-title--loading"></div>
          <div className="h-225 ml-10 mr-10">
            {_.range(0, 3).map(i => (
              <div key={i} className="dealLossReason-listItem--loading" />
            ))}
          </div>
          <div className="dealLossReason-btn-loading"></div>
        </div>
      </div>
    );
  },
  renderContent: function() {
    return (
      <div className="bg-white u-boxShadow-light br-4 b-light lh-normal">
        <div className="d-f">
          <div className="w-230">
            <div className="d-tc p-5 p-r dealLossReason-datePicker">
              <span className="ta-c d-b fs-16 mb-10 fw-bold c-darkGray">
                Congelar até quando?
              </span>

              <DatePicker
                selectedDate={this.state.unfreezeDate}
                onSelectDate={this.onSelectDate}
              />
            </div>
          </div>

          <div className="w-230 d-tc p-5 p-r bg-lightGreyBlue">
            <span className="ta-c d-b fs-16 mb-10 fw-bold c-darkGray">
              Por que foi congelado?
            </span>
            <div className="h-145 ovx-hidden ovy-auto dealLossReasonList fs-14">
              <ul>
                {this.state.reasons.map((reason) => (
                  <li
                    key={reason.id}
                    className="selector-item d-f jc-sb"
                    onClick={() => this.onSelectReason(reason)}
                  >
                    <span className="fs-14">{reason.name}</span>
                    <div className="ml-5">
                      <BooleanInput
                        type="radioButton"
                        checked={reason.id === this.state.selectedReasonId}
                        border="thick"
                        placement="right"
                        color="grey">
                      </BooleanInput>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <div className="dealLossReason w-100"></div>
            <TextArea
              width="220"
              height="68"
              maxHeight="68"
              value={this.state.description}
              onChange={this.onChangeDescription}
              placeholder="Comentário (opcional)"
              className="ovf-h pr-25"
              maxLength={255}
              isDisabled={!this.hasSelectedReason()}
              showMaxLengthCounter={true} />
            <Tooltip block={true} title={this.getSaveButtonMessage()}>
              <Button
                className="w-100 fs-12 fw-600 mt-10"
                type="primary"
                onClick={this.onFreeze}
                disabled={!this.areFieldsValid()}
              >
                Salvar
              </Button>
            </Tooltip>
          </div>
        </div>

        <div className="p-20 d-f align-center jc-center bg-lightGreyBlue">
          <Icon icon="question-sign" className="c-link" />
          <a
            className="fst-i ml-10"
            href={FAQ_URL}
            target="_blank"
          >
            O que acontece quando congelamos um negócio?
          </a>
        </div>
      </div>
    );
  },
  render: function() {
    return (
      <div className="mb-20" ref="container">
        {
          this.state.frozen
          ? <hr className="separator" />
          : null
        }
        {
          this.state.frozen
          ? <div className="mb-15">
              <div className="u-flex-center mb-10">
                <div className="custom-glyphicon icon-freeze c-primaryBlue fs-22" style={{opacity: 0.6}}>
                </div>
                <h5 className="m-0 ml-10">Negócio congelado</h5>
              </div>
              <div className="c-normalGrey fs-12">
                Congelado em: {this.getFormattedFrozenDate()}
              </div>
              <div className="c-normalGrey fs-12">
                {this.getDaysToUnfreezeMessage()}
              </div>
              <div className="c-normalGrey fs-12">
                Motivo de congelamento: {this.renderSelectedReason()}
              </div>
            </div>
          : null
        }
        <Button
          className="w-100 ta-l mb-5"
          type={this.getType()}
          onClick={this.onClick}
          disabled={this.state.saving}
        >
          <Icon custom icon={this.getIcon()} />
          <span>{this.getText()}</span>
        </Button>
        {
          this.state.frozen
          ? <hr className="separator" />
          : null
        }
        <Popbox
          isVisible={this.state.showPopbox}
          onClose={this.onClosePopbox}
          anchor={this.refs.container}
          horizontalPositions={{ anchor: "right", target: "right" }}
        >
          {
            this.state.loading
            ? this.renderPlaceholder()
            : this.renderContent()
          }
        </Popbox>
      </div>
    );
  }
});

module.exports = FreezeDealButton;



// WEBPACK FOOTER //
// ./app/screens/Deals/components/FreezeDealButton/freeze-deal-button.jsx